<template>
  <client-only>
    <article
      :class="{ placeholder: placeholder }"
      class="picture"
      @click="handleClickOnPost"
    >
      <template v-if="model && model.webstar">
        <div 
          class="img locked" 
          :style="ownCssVars"
        >

          <div class="blocked-container-facade">
            <div class="blocked-container">
              <img class="lock" src="/img/lock-white.png" :alt="content.name" />

              <div 
                class="message-container"
                v-if="data.front_container == 'tokens'"
              >
                <div class="message">
                  {{
                    $t("tokens_post_locked.top_message", {
                      tokens: data.tokens_quantity,
                    })
                  }}
                </div>
                <div class="message bottom">
                  {{ $t("tokens_post_locked.bottom_message") }}
                </div>
              </div>
            </div>

            <span v-if="content.is_hd" class="hd">HD</span>
            <span v-if="content.length" class="length">{{ movieLengthFormatted }}</span>
          </div>
          <PostBadgePremium :post="content" />

        </div>
      </template>

      <template v-else>
        <div class="img"></div>
      </template>
    </article>
  </client-only>
</template>

<script setup lang="ts">
import _NuxtApp from "~/types/NuxtApp";
import { PostData, PostContent } from "~/types/Post";

const { $EventBus, $auth } = <_NuxtApp>useNuxtApp();
const $router = useRouter();

interface __Props {
  data: PostData;
  content: PostContent;
  placeholder?: boolean;
  model?: any;
  cssVars?: any;
  link?: any;
}

const {
  data,
  content,
  placeholder,
  model,
  cssVars,
  link,
} = withDefaults(defineProps<__Props>(), {
  placeholder: false,
  model: null,
  cssVars: null,
  link: null,
});

if (content === undefined && !placeholder) {
  throw new Error("At least one, picture or placeholder, is required");
}

const ownCssVars = computed(() => {
  const css = { ...cssVars };
  const { width, height } = content.dimentions; // Should use it, but are wrong
  css.aspectRatio = `600 / 800`;
  return css;
});

function handleClickOnPost() {
  // If user is not logged, redirect to buy tokens
  if ($auth.check() && data.front_container === "tokens") {
    $EventBus.openUnlockPostWithTokens(data, model);
  } else {
    $router.push(link);
  }
}
</script>

<style scoped lang="scss">
.picture {
  flex-grow: 0;
  flex-basis: 0;
  transition: width 0.5s ease;
  width: 100%;
  cursor: pointer;

  .img {
    background-color: var(--pallete_dark_color);
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-bottom: 0.5em;
    transition: height 0.5s ease;
    width: 100%;

    img {
      width: 100%;
    }

    span.hd {
      position: absolute;
      left: 5px;
      top: 5px;
      padding: 3px;
      font-weight: bold;
      border-radius: 2px;
      background-color: var(--pallete_dark_color);
      color: #ffffff;
    }

    span.length {
      position: absolute;
      right: 5px;
      bottom: 5px;
      padding: 3px;
      border-radius: 2px;
      font-size: 13px;
      background-color: var(--pallete_dark_color);
      color: #ffffff;
    }

    .preview-wrapper {
      opacity: 0;
      transition: opacity 0.3s linear;

      &.active {
        opacity: 1;
      }
    }

    .preview-wrapper.active {
      .preview {
        background-color: var(--pallete_dark_color);
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        video {
          /*object-fit: cover;*/
          overflow: hidden;
          min-width: 100%;
          min-height: 100%;
        }
      }

      .preview-unavailable {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.25);
      }
    }
  }

  &.placeholder {
    .img {
      background-color: rgba(128, 128, 128, 0.25);
    }

    .text {
      .description {
        background-color: rgba(128, 128, 128, 0.25);
        height: 1em;
      }

      .name {
        background-color: rgba(128, 128, 128, 0.25);
        height: 1em;
      }
    }
  }

  .locked {
    z-index: 1;

    &:after {
      content: "";
      background: var(--background);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      opacity: 0.4;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: -1;
    }

    img {
      width: 100%;
      max-height: 95vh;
    }
  }
}

.blocked-container-facade {
  display: flex;
  width: 100%;
  height: 100%;

  position: absolute;
  z-index: 2;

  .blocked-container {
    margin-inline: auto;
    margin-block: auto;
    display: flex;
    flex-direction: column;

    .lock {
      max-width: 15%;
      margin-inline: auto;
    }
  
    .message-container {
      margin-block: 0.5em 0;

      .message {
        color: #a7a8ab;
        text-align: center;
        font-size: 0.8rem;

        @media (min-width: 500px) {
          font-size: 1.5rem;
        }
        @media (min-width: 375px) {
          font-size: 1rem;
        }
        
        &.bottom {
          margin-block: 0.5em 0;
          font-size: 0.75rem;

          @media (min-width: 500px) {
            font-size: 1.4rem;
          }
          @media (min-width: 375px) {
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}
</style>
